@if (item.isLocked) {
  <button
    class="relative flex w-full overflow-hidden rounded-lg text-greyscale-400 no-underline transition-all duration-300 ease-sidebar hover:bg-primary-50"
    [class]="
      isCollapsed
        ? 'h-12 w-12 items-center justify-center gap-0 px-3 py-3'
        : 'h-12 items-start gap-4 px-6 py-3'
    "
    [pTooltip]="'lockedButton.tooltip' | transloco"
    tooltipPosition="right"
    [attr.data-testid]="item.testId || item.label"
    pRipple
    (click)="packLimitationService.openModal(limitedFeatures.Client)"
  >
    <div class="flex shrink-0 items-center justify-center">
      <lucide-icon name="lock" [size]="24" class="h-6 w-6"></lucide-icon>
    </div>

    <span
      class="whitespace-nowrap font-source-sans text-base font-normal leading-6 transition-all duration-300 ease-out"
      [class]="isCollapsed ? 'invisible w-0 opacity-0' : 'pt-0.5'"
    >
      {{ item.label | transloco }}
    </span>

    @if (item.badge && item.badge > 0 && !isCollapsed) {
      <span
        class="ml-auto flex h-5 min-w-5 items-center justify-center rounded-[10px] bg-error-500 px-[6px] py-[2px] text-xs font-semibold text-white"
      >
        {{ item.badge }}
      </span>
    }
  </button>
} @else {
  <a
    [routerLink]="item.route"
    routerLinkActive="!bg-primary-100 !text-primary-700 [&>div]:!text-primary-700"
    [routerLinkActiveOptions]="{ exact: false }"
    class="relative flex overflow-hidden rounded-lg text-greyscale-900 no-underline transition-all duration-300 ease-sidebar hover:bg-primary-50 hover:text-primary-600 [&:hover>div]:text-primary-600"
    [class]="
      isCollapsed
        ? 'h-12 w-12 items-center justify-center gap-0 px-3 py-3'
        : 'h-12 items-start gap-4 px-6 py-3'
    "
    [pTooltip]="isCollapsed ? (item.label | transloco) : ''"
    tooltipPosition="right"
    [attr.data-testid]="item.testId || item.label"
    (click)="item.onClick?.()"
    pRipple
  >
    <div
      class="relative flex shrink-0 items-center justify-center text-greyscale-500 transition-colors duration-300 ease-out"
    >
      <lucide-icon [name]="item.icon" [size]="24" class="h-6 w-6"></lucide-icon>

      @if (item.warning) {
        <span
          class="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-orange-500"
          role="img"
          [attr.aria-label]="
            item.warningLabel ? (item.warningLabel | transloco) : null
          "
        ></span>
      }
    </div>

    <span
      class="whitespace-nowrap font-source-sans text-base font-normal leading-6 transition-all duration-300 ease-out"
      [class]="isCollapsed ? 'invisible w-0 opacity-0' : 'pt-0.5'"
    >
      {{ item.label | transloco }}
    </span>

    @if (item.badge && item.badge > 0 && !isCollapsed) {
      <span
        class="ml-auto flex h-5 min-w-5 items-center justify-center rounded-[10px] bg-error-500 px-[6px] py-[2px] text-xs font-semibold text-white"
      >
        {{ item.badge }}
      </span>
    }
  </a>
}
